<template>
  <div class="redPacketRecord">
    <!-- 选择区 -->
    <div>
      <div class="search_box">
        <span class="title">公众号appId</span>
        <el-input v-model="parameter.app_id" style="width:200px" placeholder="appId" />

        <span class="title">绑定状态</span>
        <el-select v-model="parameter.status" placeholder="请选择状态">
          <el-option
            v-for="item in status_s"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>

        <span class="title">商户id</span>
        <el-input v-model="parameter.merchant_id" style="width:200px" placeholder="请输入商户id" />
        <el-button icon="el-icon-search" type="primary" @click="(parameter.page = 1),(getData())">搜索</el-button>
        <el-button icon="el-icon-refresh-left" type="info" @click="reset">重置</el-button>
        <el-button type="success" icon="el-icon-circle-plus" @click="bandawer">绑定</el-button>
      </div>
    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="merchant_id"
          label="商户号id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="merchant_name"
          label="商户号名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="公众号appId"
          width="200"
          align="center"
        />
        <el-table-column
          prop="app_id_text"
          label="公众号名称"
          width="180"
          align="center"
        />
        <!-- <el-table-column
          prop="statusText"
          label="状态"
          width="180"
          align="center"
        >
          <template scope="scope">{{ status_s[scope.row.status].value }}</template>
        </el-table-column> -->

        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="180"
          align="center"
        />

        <el-table-column
          prop="creator"
          label="创建人"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 0" class="el-icon-warning" />
            <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 2" class="el-icon-error stopew" />
            <i v-if="scope.row.status == 3" class="el-icon-warning defaultrse" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="creator"
          label="操作"
          align="center"
          w
          width="200"
        >
          <template scope="scope">
            <el-button v-if="scope.row.status == 1" type="danger" size="mini" @click="unbind(scope.row.id)">解绑</el-button>
            <el-button v-if="scope.row.status == 0" type="warning" size="mini" @click="sendtestredbox(scope.row.id)">发送测试红包</el-button>
            <el-button v-if="scope.row.status == 0" style="margin-top:10px" type="success" size="mini" @click="refreshband(scope.row.id)">刷新绑定状态</el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <el-dialog
      title="绑定"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <banding @updata="updata" />
    </el-dialog>
    <el-dialog
      title="发送测试红包"
      :visible.sync="sendialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <sendtestred ref="sendiaredred" @callupdata="callupdata" />
    </el-dialog>
    <PaginationRight
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { merchantIDList, unbandlist } from '@/api/weChatMerchants.js'
import { refreshbind } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight'
import banding from './components/banding.vue'
import sendtestred from './components/sendtestred.vue'
export default {
  name: 'OfficialAccountMerchant',
  components: {
    PaginationRight,
    banding,
    sendtestred
  },
  data() {
    return {
      parameter: {
        page: 1, // 页码
        pageSize: 10, // 页数
        app_id: null, // 用户openid
        status: null, // 状态
        merchant_id: null // 	商户id
      },
      status_s: [{ id: null, value: '全部' }, { id: 0, value: '未生效' }, { id: 1, value: '正常 ' }, { id: 2, value: '禁用' }],
      tableData: [],
      total: null,
      loading: false,
      dialogVisible: false,
      sendialogVisible: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await merchantIDList({ ...this.parameter })
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSizeone(e) {
      this.parameter.pageSize = e
      this.getData()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getData()
    },
    reset() {
      this.parameter = {
        page: 1, // 页码
        pageSize: 10, // 页数
        app_id: null, // 用户openid
        status: null, // 状态
        merchant_id: null // 	商户id
      }
      this.getData()
    },
    bandawer() {
      this.dialogVisible = true
    },
    updata() {
      this.dialogVisible = false
      this.getData()
    },
    unbind(id) {
      this.$confirm('确定解绑吗?, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        unbandlist({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.getData()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    sendtestredbox(id) {
      this.sendialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.sendiaredred.send(id)
      })
      console.log('id', id)
    },
    callupdata() {
      this.sendialogVisible = false
      this.getData()
    },
    refreshband(id) {
      this.$confirm('确定刷新吗?, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log('1111')
        refreshbind({
          bind_id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '刷新成功!'
          })
          this.getData()
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style>
.redPacketRecord{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
}

.selectionArea{
  margin-bottom: 20px;
  display: flex;
}

.item{
     display: flex;
     align-items: center;
     margin-right: 30px;
}

.title{
  font-size: 14px;
  color: #0f0f0f;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.search_box{
  margin-bottom:20px;
}
@media (max-width: 768px){
  .title{
    align-items:center;
    justify-content:space-between;
  }
}
</style>
